import {
  Box,
  CircularProgress,
  FormControl,
  InputAdornment,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { t } from "i18next";

const CoreSearchBar = ({
  placeholder = `${t("Search")}...`,
  value,
  handleChange,
  isLoading = false,
  ...props
}) => {
  const handleSearchChange = (event) => {
    const term = event.target.value;
    if (handleChange) {
      handleChange(term);
    }
  };

  return (
    <Box width="100%">
      <FormControl
        fullWidth
        size="small"
        disabled={props.disabled}
        error={props.error}
        required={props.required}
      >
        <TextField
          size="small"
          disabled={props.disabled}
          placeholder={placeholder}
          value={value}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                {isLoading ? <CircularProgress size={14} /> : <SearchIcon />}
              </InputAdornment>
            ),
          }}
        />
      </FormControl>
    </Box>
  );
};

export default CoreSearchBar;
